import { CommunicationOptions } from "../../models/employers/communicationOptions";

export const editCommunicationSettings = async (
    API_URL: string,
    token: string,
    employerId: string,
    communicationOptions: CommunicationOptions
) => {
    await fetch(
        `${API_URL}/employers/${employerId}/communication-options`,
        {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(communicationOptions)
        }
    );

    return { success: true };
}